import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Modal } from "seed/helpers"
import l from "components/util/l";
import PaginationFooter from "components/util/helpers/PaginationFooter";
import CopyClipboardButton from "components/util/helpers/CopyClipboardButton";
import AccessForm from "components/presentation/forms/collaboration/AccessForm";
import SharedPersonItem from "components/presentation/forms/collaboration/Collaboration.sub.Item.view";
import Permissions from "components/presentation/sections/permissions/Permissions";
import "styles/css/presentation/Collaboration.css";

const CollaborationView = ({
  flow,
  flowUrl,
  pageNum,
  participantGroups,
  roleOptions,
  search,
  selectedRoleId,
  totalPages,
  isAdmin,
  isAccessModelOpen,
  isPermissionModelOpen,
  onCompleteAccess,
  onChangeParticipantRole,
  onChangeRole,
  onChangeSearch,
  onClickPage,
  onClickChangeOrganizationParticipantRole,
  onClickRemoveParticipant,
  onOpenAccessModel,
  onCloseAccessModel,
  onClickOpenPermissionModel,
  onClickClosePermissionModel,
}) => (
  <>
    <div className="card w-100 h-100">

      <div className="card-header">
        <h3 className="card-header-title">{l("Compartir%GA064")}</h3>
      </div>

      <div className="card-body pt-3 pb-4 px-0 overflow-auto">

        <div className="h-100  px-5 overflow-auto">

          <span className="collaboration-link-title dropdown-header w-100 px-1">{l("Liga de acceso%PA032")}</span>
          <div className="d-flex justify-content-between collaboration-link-container">
            <div id="collaboration-link-url">
              <div className="px-1 rounded w-100">
                <a href={flowUrl}>{flowUrl}</a>
              </div>
            </div>

            <div className="collaboration-link-copy">
              <CopyClipboardButton link={flowUrl} style={{ width: "100%", height: "100%" }} />
            </div>
          </div>

          <div className="collaboration-access-container h-100 w-100 px-2 py-2 mt-2">

            <SharedPersonItem
              roleOptions={roleOptions}
              isOwner={true}
              owner={flow?.user}
            />

            {/* Filters */}
            <div className="d-flex mt-3 mb-2">
              <select className="custom-select w-auto mr-2" value={selectedRoleId} onChange={onChangeRole}>
                <option value="">{l("Todos%GA030")}</option>
                {roleOptions.map((role) => (
                  <option key={role.value} value={role.value}>{role.label}</option>
                ))}
              </select>
              <input
                type="text"
                className="form-control"
                placeholder={l("Buscar por correo, nombre o apellido%PA096")}
                value={search}
                onChange={onChangeSearch}
              />
            </div>

            {participantGroups.length == 0 && (
              <div className="text-center text-muted py-4">{l("Sin resultados%GA010")}</div>
            )}

            {participantGroups.map((group) => (
              <div key={`role-${group.roleId}`}>
                <span className="dropdown-header px-1 mt-3">{group.roleName ?? l("Sin perfil%PA299")}</span>
                {group.participants.map((participant) => (
                  <SharedPersonItem
                    key={participant.id}
                    participant={participant}
                    roleOptions={roleOptions}
                    owner={flow?.user}
                    onChangeParticipantRole={onChangeParticipantRole}
                    onClickChangeOrganizationParticipantRole={onClickChangeOrganizationParticipantRole}
                    onClickRemoveParticipant={onClickRemoveParticipant}
                  />
                ))}
              </div>
            ))}

            {totalPages > 1 && (
              <PaginationFooter
                pageNum={pageNum}
                totalPages={totalPages}
                onClickPage={onClickPage}
              />
            )}

            <div className="d-flex justify-content-end mt-4">
              {isAdmin &&
                <button className="btn btn-outline-primary mr-2" onClick={onClickOpenPermissionModel}>
                  <i class="fas fa-user-friends mr-1"></i> {l("Personalizar roles%PA185")}
                </button>}
              <button className="btn btn-primary" onClick={onOpenAccessModel}>
                <i class="fas fa-plus mr-1"></i> {l("Crear acceso%PA021")}
              </button>

            </div>
          </div>
        </div>

      </div>

    </div>

    {isAccessModelOpen && (
      <Modal
        width={550}
        height={500}
        flowId={flow.id}
        roleOptions={roleOptions}
        onCompleteAccess={onCompleteAccess}
        component={AccessForm}
        onClose={onCloseAccessModel}
      />
    )}

    {isPermissionModelOpen && (
      <Modal
        width={800}
        height={window.innerHeight - 100}
        flow={flow}
        isAdmin={isAdmin}
        onClose={onClickClosePermissionModel}
        component={Permissions}
      />
    )}

  </>
);

export default CollaborationView;